export const UPDATE_HTTP_STATUS = 'UPDATE_HTTP_STATUS';

export function updateHttpStatus(status) {
    return {
        type: UPDATE_HTTP_STATUS,
        payload: status,
    };
}
